import React, { useContext, useState, useRef } from "react";
import {Card, Overlay, Button} from "react-bootstrap";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import firebase from "firebase/app";

import "./style.css";

const SearchLead = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [leadsData, setLeadsData] = useState("");
  const userRef = firestore.collection("usersData");
  const leadsRef = firestore.collection("leadsData");
  const inboxRef = firestore.collection("usersInbox");
  const leadsDoc = []

  const [showOverlay, setShowOverlay] = useState(false);
  const [currentClickedLead, setCurrentClickedLead] = useState("");
  const overlayTarget = useRef(null);

  const [userFavLeads, setUserFavLeads] = useState([]);
  const [showFavIconFull, setShowFavIconFull] = useState('none');
  const [showFavIconEmpty, setShowFavIconEmpty] = useState('unset');
  const [leadSubmitMessage, setLeadSubmitMessage] = useState('');
  const [showLeadMsg, setShowLeadMsg] = useState('none');
  const [toggleSubmitMsg,setToggleSubmitMsg] = useState(false)

  const max_chars = 200;
  const [charsLeft, setCharsLeft] = React.useState(max_chars);

  const incrementFbInstanceBy1 = firebase.firestore.FieldValue.increment(1)


  React.useEffect(() => {
    userRef.doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
          setUserFavLeads(data.userFavLeads || [])
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  React.useEffect(() => {
    leadsRef.get().then((querySnapshot) => {      
        querySnapshot.forEach((doc) => {
          leadsDoc.push({ id: doc.id, ...doc.data() })
        })
        setLeadsData(leadsDoc);
    })
  }, []);

  if (!userData || !leadsData) return <div>Loading Data</div>;

  const sections = [
    { title: "פרופיל", url: "/Profile"},
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "" },
  ];

  const handleFavLead = async (leadid, isLiked, leadUserId) =>{
    if(leadUserId == user.uid) return
    if(!isLiked){
      try {
      await userRef.doc(user.uid).set(
        {
          userFavLeads: [...userFavLeads, leadid]
        },
        { merge: true }
      );
      } catch (error) {
        console.error("Error Liking The Lead", error);
      }
      setUserFavLeads([...userFavLeads, leadid])
    }
    else if(isLiked){
      let tempFavLeadsArr = userFavLeads.filter(arrLead => arrLead !== leadid)
      setUserFavLeads(tempFavLeadsArr)
      await userRef.doc(user.uid).update({userFavLeads: tempFavLeadsArr})
    }   
  }

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    var input = event.target.value;
    setCharsLeft(max_chars - input.length);
    if(charsLeft >= 0) setLeadSubmitMessage(value);
  }

  const handleLeadMsg = async () =>{
    if(!leadSubmitMessage) return
    if(currentClickedLead.userId == user.uid) return
    try {
      await inboxRef.doc().set(
        {
          sendingUser: user.uid,
          receivingUser: currentClickedLead.userId,
          message: leadSubmitMessage,
          leadId: currentClickedLead.id
        }
      );
      onExitOverlay()
      setToggleSubmitMsg(true)
      } catch (error) {
        console.error("Error Adding Message To Database", error);
      }
      try {
      await userRef.doc(currentClickedLead.userId).update({numberOfUnreadInboxes: incrementFbInstanceBy1})
      } catch (error) {
        console.error("Error Updating numbOfUndreadInboxes In Database", error);
      }
      try {
      await leadsRef.doc(currentClickedLead.id).update({numberOfSubmits: incrementFbInstanceBy1})
      } catch (error) {
        console.error("Error Updating numberOfSubmits in Database", error);
      }
  }

  const onExitOverlay = () =>{
    setShowLeadMsg('none')
    setToggleSubmitMsg(false)
  }

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} />
      </Container>
      <hr />
      <Overlay target={overlayTarget.current} show={showOverlay} placement="auto" onExit={onExitOverlay}>
        {({
          placement,
          scheduleUpdate,
          arrowProps,
          outOfBoundaries,
          show: _show,
          onExit,
          ...props
        }) => (
          <div
            {...props}
            style={{
              backgroundColor: '#999999e5',
              // padding: '200px 100px',
              color: 'white',
              borderRadius: 5,
              width: '99%',
              height: '99%',
              display: 'flex',
              justifyContent: 'center', 
              direction: 'rtl',
              textAlign: 'right',
              ...props.style,
            }}
          >
          <Card style={{ width: "50%"}}>
          <i className="fa fa-window-close mb-2 text-muted close-overlay-icon" aria-hidden="true" onClick={() => setShowOverlay(!showOverlay)}></i>
          {currentClickedLead.userId == user.uid ? 
           <label style={{margin: '5px'}} className="mb-2 text-muted">
              זו הפנייה שאתה פירסמת לכן לא תוכל להגיש מועמדות.
            </label> :
            null
          }
          <Card.Body>
            <Card.Title className="mb-2 text-muted">{currentClickedLead.leadExp}</Card.Title>
            <Card.Subtitle style={{marginTop: '40px'}} className="mb-2 text-muted">
              {currentClickedLead.leadLocation}
            </Card.Subtitle>
            <Card.Text style={{marginTop: '40px'}} className="mb-2 text-muted">
              {currentClickedLead.leadDescription}
            </Card.Text>
            <Card.Link style={{lineHeight: '10', marginLeft: '30px'}} href={`/Profile/${currentClickedLead.userId}`} className="mb-2 text-muted">{currentClickedLead.userFullName}</Card.Link>
            <Button variant="success" onClick={()=>setShowLeadMsg('flex')}>להגשת מועמדות</Button>
            <br/>  
            <div className="update-page-contact" style={{display: showLeadMsg, flexDirection: 'column'}}>
              <label className="mb-2 text-muted">
                פרט בקצרה עליך והתאמתך להפניה זו
              </label>
              <div className="leadmsg-labelinput-wrapper">
                <textarea
                  maxLength = {max_chars}
                  style={{ width: "100%", height: "135px" }}
                  // className="leadmsg-update-input"
                  onChange={event => onChangeHandler(event)}
                ></textarea>
              </div>
              <p className="mb-2 text-muted">תווים שנשארו: {charsLeft}</p>
              <Button variant="success" onClick={handleLeadMsg}>הגש</Button>
            </div>
            <p style={{color: '#218838'}} className='addlead-page-label mb-2'>{toggleSubmitMsg ? "ההודעה שלך נשלחה בהצלחה ותתקבל אצל מפרסם ההפניה.": ""}</p>
          </Card.Body>
          </Card>
          </div>
        )}
      </Overlay>

      <div className='searchlead-page-cards-wrapper'>
        {leadsData.map((lead)=>
        <Card style={{ width: "18rem" }}>
          <Card.Body>
            <Card.Title ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>{lead.leadExp} <span className='lead-post-date'>{lead.leadDate}</span></Card.Title>
            <Card.Subtitle className="mb-2 text-muted" ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>
              {lead.leadLocation}
            </Card.Subtitle>
            <Card.Text className='card-text-outside' ref={overlayTarget} onClick={() => {setShowOverlay(!showOverlay)
              setCurrentClickedLead(lead)}}>
              {lead.leadDescription}
            </Card.Text>
            <div className = 'username-fav-wrapper'>
            <Card.Link>{lead.userFullName}</Card.Link>
            <i style={{cursor: 'pointer', marginRight: "150px",fontSize:'20px',color:'red', display: userFavLeads.includes(lead.id)? 'unset':'none'}} class="fa fa-heart" onClick={()=>handleFavLead(lead.id, true,lead.userId)}></i>
            <i style={{cursor: 'pointer', marginRight: "150px",fontSize:'20px',color:'red', display: userFavLeads.includes(lead.id)? 'none':'unset'}} class="fa fa-heart-o" onClick={()=>handleFavLead(lead.id,false, lead.userId)}></i>
            </div>
          </Card.Body>
        </Card>
        )}
        
      </div>
    </div>
  );
};

export default SearchLead;
